module.exports = __webpack_public_path__ + "img/nextIconGrey.e107615f.svg";